import SessionEventProto from "../session-event-proto";
import {EntityType} from "../../gd/const/item";

type Header = {
    actionItemsStorageId   : ID
    data                    : any
}

export default class SessionActionItemsStorageDelta extends SessionEventProto {

    private header  : Header

    constructor(sessionEvent:any) {
        super(sessionEvent)

        this.header     = {
            actionItemsStorageId    : sessionEvent.id,
            data                    : sessionEvent.data
        }
    }

    process() {

        if (this.fromSID === gd.sessionId) {
            return false;
        }

        if (this.isDifferentCompany()) return false;

        gd.modelBus.newUpdate(EntityType.ACTION_ITEMS_STORAGE, this.method, this.header.actionItemsStorageId, this.header.data, this.header);
    }
};
